module.exports = __webpack_public_path__ + "/8f818cb8a793d0cf9a1bcbd7f5849abf.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/logo/hellofax.svg
 ** module id = 767
 ** module chunks = 0
 **/